import { useNavigate, useLocation } from "react-router-dom";
import { Home, Search, Plus, Heart, User } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

/**
 * Bottom navigation bar component
 * Shows on all pages except login, register, admin pages
 */
const BottomNav = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { isAuthenticated } = useAuth();

  // Don't show on these pages
  const hiddenPaths = ["/login", "/register", "/admin", "/admin/login"];
  if (hiddenPaths.some(path => location.pathname.startsWith(path))) {
    return null;
  }

  const isActive = (path) => {
    if (path === "/" || path === "/grid") {
      return location.pathname === "/" || location.pathname === "/grid";
    }
    return location.pathname.startsWith(path);
  };

  return (
    <nav className="fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 z-50">
      <div className="flex items-center justify-around py-2 max-w-lg mx-auto">
        <button 
          onClick={() => navigate("/")}
          className={`flex flex-col items-center p-2 ${isActive("/") ? "text-green-700" : "text-gray-400"}`}
        >
          <Home className="w-6 h-6" />
          <span className="text-xs mt-1">Hjem</span>
        </button>
        
        <button 
          onClick={() => navigate("/utstyrsguide")}
          className={`flex flex-col items-center p-2 ${isActive("/utstyrsguide") ? "text-green-700" : "text-gray-400"}`}
        >
          <Search className="w-6 h-6" />
          <span className="text-xs mt-1">Guide</span>
        </button>
        
        <button 
          onClick={() => navigate("/create")}
          className="flex flex-col items-center -mt-4"
        >
          <div className="bg-green-700 rounded-full p-3 shadow-lg">
            <Plus className="w-6 h-6 text-white" />
          </div>
          <span className="text-xs mt-1 text-gray-600">Selg</span>
        </button>
        
        <button 
          onClick={() => navigate("/favorites")}
          className={`flex flex-col items-center p-2 ${isActive("/favorites") ? "text-green-700" : "text-gray-400"}`}
        >
          <Heart className="w-6 h-6" />
          <span className="text-xs mt-1">Favoritter</span>
        </button>
        
        <button 
          onClick={() => isAuthenticated() ? navigate("/") : navigate("/login")}
          className={`flex flex-col items-center p-2 ${isActive("/profile") ? "text-green-700" : "text-gray-400"}`}
        >
          <User className="w-6 h-6" />
          <span className="text-xs mt-1">Profil</span>
        </button>
      </div>
    </nav>
  );
};

export default BottomNav;
